import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export const LegalNotice = () => {
  return (
    <div data-testid="legal-notice-page" className="weblax-section">
      <div className="weblax-container">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary mb-8">
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
          
          <h1 className="weblax-heading-display mb-8">Mentions légales</h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">1. Éditeur du site</h2>
              <p className="text-muted-foreground">
                Le site weblax.fr est édité par :<br />
                <strong>Weblax</strong><br />
                Société par actions simplifiée (SAS)<br />
                Capital social : 10 000 €<br />
                Siège social : Paris, France<br />
                SIRET : XXX XXX XXX XXXXX<br />
                TVA Intracommunautaire : FR XX XXX XXX XXX
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">2. Directeur de la publication</h2>
              <p className="text-muted-foreground">
                Le directeur de la publication est le représentant légal de la société Weblax.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">3. Hébergement</h2>
              <p className="text-muted-foreground">
                Le site est hébergé par :<br />
                <strong>Vercel Inc.</strong><br />
                340 S Lemon Ave #4133<br />
                Walnut, CA 91789<br />
                États-Unis
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">4. Contact</h2>
              <p className="text-muted-foreground">
                Email : contact@weblax.fr<br />
                Téléphone : +33 6 85 80 20 16
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">5. Propriété intellectuelle</h2>
              <p className="text-muted-foreground">
                L'ensemble du contenu de ce site (textes, images, vidéos, logos, etc.) est protégé par le droit d'auteur. Toute reproduction, représentation, modification ou exploitation non autorisée est interdite.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">6. Limitation de responsabilité</h2>
              <p className="text-muted-foreground">
                Weblax s'efforce d'assurer l'exactitude des informations diffusées sur ce site. Toutefois, Weblax ne peut être tenue responsable des erreurs, omissions ou résultats obtenus suite à l'utilisation de ces informations.
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-border">
            <p className="text-sm text-muted-foreground">
              Dernière mise à jour : Janvier 2024
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PrivacyPolicy = () => {
  return (
    <div data-testid="privacy-policy-page" className="weblax-section">
      <div className="weblax-container">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary mb-8">
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
          
          <h1 className="weblax-heading-display mb-8">Politique de confidentialité</h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">1. Introduction</h2>
              <p className="text-muted-foreground">
                Weblax accorde une grande importance à la protection de vos données personnelles. Cette politique de confidentialité vous informe sur la manière dont nous collectons, utilisons et protégeons vos données.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">2. Données collectées</h2>
              <p className="text-muted-foreground mb-4">
                Nous collectons les données suivantes :
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone (optionnel)</li>
                <li>Nom de l'entreprise (optionnel)</li>
                <li>Données de navigation (cookies)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">3. Utilisation des données</h2>
              <p className="text-muted-foreground mb-4">
                Vos données sont utilisées pour :
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2">
                <li>Répondre à vos demandes de contact</li>
                <li>Établir des devis personnalisés</li>
                <li>Vous envoyer notre newsletter (si consentement)</li>
                <li>Améliorer nos services</li>
                <li>Respecter nos obligations légales</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">4. Base légale</h2>
              <p className="text-muted-foreground">
                Le traitement de vos données repose sur votre consentement explicite et notre intérêt légitime à développer notre activité commerciale.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">5. Conservation des données</h2>
              <p className="text-muted-foreground">
                Vos données sont conservées pendant 3 ans à compter du dernier contact, sauf obligation légale de conservation plus longue.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">6. Vos droits</h2>
              <p className="text-muted-foreground mb-4">
                Conformément au RGPD, vous disposez des droits suivants :
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2">
                <li>Droit d'accès à vos données</li>
                <li>Droit de rectification</li>
                <li>Droit à l'effacement</li>
                <li>Droit à la limitation du traitement</li>
                <li>Droit à la portabilité</li>
                <li>Droit d'opposition</li>
              </ul>
              <p className="text-muted-foreground mt-4">
                Pour exercer ces droits, contactez-nous à : contact@weblax.fr
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">7. Sécurité</h2>
              <p className="text-muted-foreground">
                Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-border">
            <p className="text-sm text-muted-foreground">
              Dernière mise à jour : Janvier 2024
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CookiesPolicy = () => {
  return (
    <div data-testid="cookies-policy-page" className="weblax-section">
      <div className="weblax-container">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary mb-8">
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
          
          <h1 className="weblax-heading-display mb-8">Politique des cookies</h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">1. Qu'est-ce qu'un cookie ?</h2>
              <p className="text-muted-foreground">
                Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette, smartphone) lors de votre visite sur notre site. Il permet de stocker des informations relatives à votre navigation.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">2. Types de cookies utilisés</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold mb-2">Cookies essentiels</h3>
                  <p className="text-muted-foreground">
                    Nécessaires au fonctionnement du site. Ils ne peuvent pas être désactivés.
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Cookies analytiques</h3>
                  <p className="text-muted-foreground">
                    Nous permettent de comprendre comment vous utilisez notre site pour l'améliorer.
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Cookies de préférences</h3>
                  <p className="text-muted-foreground">
                    Mémorisent vos préférences (langue, thème) pour personnaliser votre expérience.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">3. Durée de conservation</h2>
              <p className="text-muted-foreground">
                Les cookies sont conservés pour une durée maximale de 13 mois conformément aux recommandations de la CNIL.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">4. Gestion des cookies</h2>
              <p className="text-muted-foreground">
                Vous pouvez à tout moment modifier vos préférences en matière de cookies via les paramètres de votre navigateur ou notre bannière de consentement.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">5. Plus d'informations</h2>
              <p className="text-muted-foreground">
                Pour toute question concernant notre utilisation des cookies, contactez-nous à : contact@weblax.fr
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-border">
            <p className="text-sm text-muted-foreground">
              Dernière mise à jour : Janvier 2024
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Licenses = () => {
  return (
    <div data-testid="licenses-page" className="weblax-section">
      <div className="weblax-container">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-primary mb-8">
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>
          
          <h1 className="weblax-heading-display mb-8">Licences & Solutions</h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <p className="text-muted-foreground text-lg">
                Weblax propose des solutions et licences adaptées à vos besoins pour vous accompagner dans votre transformation digitale.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">CMS & Gestion de contenu</h2>
              <p className="text-muted-foreground">
                Nous utilisons et configurons les meilleurs CMS du marché (WordPress, Shopify, etc.) pour vous offrir une solution de gestion de contenu adaptée à vos besoins.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">Outils SEO</h2>
              <p className="text-muted-foreground">
                Accès aux meilleurs outils de suivi SEO et d'analyse de performance pour monitorer votre visibilité en ligne.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">Hébergement managé</h2>
              <p className="text-muted-foreground">
                Solutions d'hébergement haute performance avec monitoring, sauvegardes automatiques et support technique inclus.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">Support Premium</h2>
              <p className="text-muted-foreground">
                Bénéficiez d'un support prioritaire avec des temps de réponse garantis et un interlocuteur dédié.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="weblax-heading-2 mb-4">Automatisations</h2>
              <p className="text-muted-foreground">
                Mise en place d'automatisations marketing et business pour optimiser vos processus et gagner en efficacité.
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-border flex flex-col sm:flex-row gap-4">
            <Link to="/contact">
              <Button className="weblax-btn-primary">
                Nous contacter
              </Button>
            </Link>
            <Link to="/tarifs">
              <Button variant="outline" className="weblax-btn-secondary">
                Voir nos tarifs
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
